import axios from "axios";
import { getToken } from "../../routes/cookies";

const getApiBaseUrl = () => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    if (hostname !== "localhost" && hostname !== "127.0.0.1" && !hostname.startsWith("192.168.")) {
      return "https://api.bagdamahasabha.org/api/admin";
    }
  }
  return process.env.REACT_APP_API_BASE_URL || "https://api.bagdamahasabha.org/api/admin";
};

const axiosInstance = axios.create({
  baseURL: getApiBaseUrl(),
  timeout: 10000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },

  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;